<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-indent: 00em;">I am thankful for those pioneer historians and researchers who dedicated their lives pursuing the truth and sharing their knowledge with the world.</p><br/>
<p style="text-indent: 00em;">I am especially thankful for the works of Yosef A. A. ben-Jochannan, Ernest A. Wallis-Budge, George G.M. James, Philip Jenkins, Diarmaid MacCulloch, Brian R. Nelson, William I. Robinson, and Brian Tierney.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?5a31bf6e